import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CITIES } from "../../lib/site-data";
import { MapPin } from "lucide-react";
import SectionLabel from "./SectionLabel";

export default function CityChapters() {
  const [activeCity, setActiveCity] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setActiveCity((c) => (c + 1) % CITIES.length), 900);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      id="cities"
      data-testid="city-chapters-section"
      className="relative bg-[#0A0A0A] text-white section-pad overflow-hidden"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-3">
            <SectionLabel dark dataTestId="cities-overline">
              City Chapters
            </SectionLabel>
            <h2
              data-testid="cities-headline"
              className="font-display mt-7 text-xl md:text-2xl font-semibold tracking-tight leading-snug text-white"
            >
              Present across 6 cities.
            </h2>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-9 lg:col-start-4 text-base md:text-lg text-white/65 leading-relaxed lg:pt-2 space-y-3"
            data-testid="cities-description"
          >
            <p>
              Members join the City Chapter most relevant to them, based on where
              they live, work, frequently travel, or want to build connections.
            </p>
            <p>
              Each Chapter is further organised into industry-specific Professional Circles,
              so depth follows breadth.
            </p>
          </motion.div>
        </div>
      </div>

      {/* City boxes with rotating orange highlight */}
      <div className="container-x mt-10 md:mt-14">
        <div
          data-testid="city-boxes"
          className="grid grid-cols-3 lg:flex lg:flex-wrap lg:justify-center gap-2.5 sm:gap-3 md:gap-4"
        >
          {CITIES.map((c, i) => {
            const isActive = i === activeCity;
            return (
              <div
                key={c}
                data-testid={`city-pill-${i}`}
                className="flex items-center justify-center gap-1.5 sm:gap-2 px-2 py-2 sm:px-4 sm:py-2.5 rounded-xl border bg-white/5 backdrop-blur-sm whitespace-nowrap transition-[border-color,box-shadow] duration-300 ease-out"
                style={{
                  borderColor: isActive ? "rgba(234, 88, 12, 0.9)" : "rgba(255, 255, 255, 0.15)",
                  boxShadow: isActive
                    ? "0 0 0 1px rgba(234,88,12,0.5), 0 10px 30px -10px rgba(234,88,12,0.7)"
                    : "none",
                }}
              >
                <MapPin className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-orange-500 shrink-0" />
                <span className="font-display font-semibold text-[13px] sm:text-base md:text-lg tracking-tight text-white">
                  {c}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container-x mt-8 text-center text-sm text-white/50">
        More cities being added based on member demand.
      </div>
    </section>
  );
}
